import { Component, OnInit, effect } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { MainService } from '../../shared/main.service';
import { localStorageService } from '../../shared/localstorage.service';
import { currencyFormatfunction, SharedService } from '../../shared/shared.service';
import { ApiService } from '../../shared/api.service';
import { ExportJobService } from '../../shared/export-job.service';
import { EmbedTokenService } from '../../shared/embed-token.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DatePipe]
})
export class DashboardComponent implements OnInit {
  public old_dashboard: any = {
    active_doctors_this_month: 0,
    active_doctors_this_month_30: 0,
    active_doctors: 0,
    active_doctors_today: 0,
    total_disabled_accounts: 0,
    active_partners: 0,
    new_partners_today: 0,
    active_patients: 0,
    patients_without_contracts: 0,
    new_patients_today: 0,
    self_verified_customers: 0,
    financed_contracts: 0,
    financed_contracts_today: 0,
    overdue_accounts: 0,
    legal_overdue_contracts: 0,
    financing_errors: 0,
    late_fee: 0,
    late_fee_count: 0,
    late_fee_today: 0,
    late_fee_count_today: 0,
    financed_amount: 0,
    financed_amount_today: 0,
    claim_requests: 0,
    claim_requests_today: 0,
    claim_request_amount: 0,
    claim_request_amount_today: 0,
    claim_request_paid: 0,
    claim_request_paid_today: 0,
    zero_percent_contracts: 0,
    ten_percent_contracts: 0,
    upfront_fee: 0,
    today_upfront_fee: 0,
    today_first_recurring_fee: 0,
    first_recurring_fee: 0,
    contract_financed_requests: 0,
    deleted_split_requests: 0,
    link_opened_requests: 0,
    plan_selected_requests: 0,
    today_contract_financed_requests: 0,
    today_plan_selected_requests: 0,
    today_split_requests: 0,
    total_split_requests: 0,
    split_errors: 0,
    demand_letter_stats_data: {
      scanned: 0,
      total: 0,
      not_scanned: 0,
      completed_contracts: 0,
      active_contracts: 0,
      overdue_contracts: 0,
      cancelled_contracts: 0,
      total_settlement_contracts: 0,
      settlement_financed_amount: 0.00,
      active_total_amt: 0,
      active_total_pod: 0,
      active_total_pop: 0,
      complete_total_amt: 0,
      complete_total_pod: 0,
      complete_total_pop: 0
    }
  };
  public dashboard: any = {
    active_doctors_this_month: 0,
    active_doctors_this_month_30: 0,
    active_doctors: 0,
    active_doctors_today: 0,
    total_disabled_accounts: 0,
    active_partners: 0,
    new_partners_today: 0,
    active_patients: 0,
    patients_without_contracts: 0,
    new_patients_today: 0,
    self_verified_customers: 0,
    financed_contracts: 0,
    financed_contracts_today: 0,
    overdue_accounts: 0,
    legal_overdue_contracts: 0,
    financing_errors: 0,
    late_fee: 0,
    late_fee_count: 0,
    late_fee_today: 0,
    late_fee_count_today: 0,
    financed_amount: 0,
    financed_amount_today: 0,
    claim_requests: 0,
    claim_requests_today: 0,
    claim_request_amount: 0,
    claim_request_amount_today: 0,
    claim_request_paid: 0,
    claim_request_paid_today: 0,
    zero_percent_contracts: 0,
    ten_percent_contracts: 0,
    upfront_fee: 0,
    today_upfront_fee: 0,
    today_first_recurring_fee: 0,
    first_recurring_fee: 0,
    split_errors: 0
  };
  canExportAllProductsAccess = false;
  /** Rendered inside another product's iframe via /embed/dashboard: read-only, no admin-panel navigation. */
  embedded = this._embed.active;
  public dateForm!: UntypedFormGroup;

  is_dummy: any = this._local.customGetItem('is_dummy') ? this._local.customGetItem('is_dummy') : 0;
  subscription: any;
  timezone_subscription: any;
  opened: boolean = true;
  // firstOpened: boolean = true;
  // collapsible: boolean = false;

  messages!: Subject<any>;
  timezone: any = this._shared.getTimezone();
  cocu_id: any = this._local.customGetItem('cocu_id');
  country_id: any = this._local.customGetItem('country_id');
  minDate: any = new Date(2024, 0, 1);
  maxDate: any;
  dateRangeValue: any;
  today_start_date: any;
  today_end_date: any;
  country_sign: string = '$';
  currencySymbol: string = '$';
  country_subscription: any;
  minDates: any;
  admin_id = 0;
  uploadForm!: UntypedFormGroup;
  selectedFile: File | null = null;
  selectedFileName: string = '';
  notFoundAccounts: string[] = [];
  uploadedAccountCount = 0;
  uploadResultMessage = '';
  canUploadRecoveryReporting = false;
  /** Job keys the export service tracks these two downloads under. */
  private readonly ALL_PRODUCT_ACCOUNTS_JOB = 'all-product-accounts';
  private readonly ALL_PRODUCT_TLO_JOB = 'all-product-tlo';

  /**
   * Guards the export menu against a second click while a download is being built.
   * Read from the export service rather than a local field so it stays correct after the
   * user navigates away and back — this component is destroyed and rebuilt in between,
   * which used to re-enable the button while the request was still running.
   */
  get allProductExporting(): boolean {
    return this._exportJobs.isRunning(this.ALL_PRODUCT_ACCOUNTS_JOB, this.ALL_PRODUCT_TLO_JOB);
  }

  constructor(
    public mainService: MainService, private _local: localStorageService, private _ar: ActivatedRoute, public _shared: SharedService, private _api: ApiService,
    private datePipe: DatePipe, private _fb: FormBuilder, private _exportJobs: ExportJobService, private _embed: EmbedTokenService) {
      this.currencySymbol = this._shared.getCurrencySymbol();
    effect(() => {
      this.syncAllProductExportAccess(this.mainService.admin_array());
    });
  }

  ngOnInit() {
    this.mainService.currencySymbol$.subscribe((symbol: string) => {
      this.currencySymbol = symbol || '$';
      this.country_sign = symbol || '$';
    });
    this.country_subscription = this._ar.queryParams.subscribe((data) => {
      if (data) {
        this.cocu_id = data['cocu_id'] || this._local.customGetItem('cocu_id');
        this.country_sign = data['display_logo'] || this.currencySymbol;
        this.country_id = data['country_id'];
        this.is_dummy = data['is_dummy'];
        this.timezone = data['timezone'];
        this.maxDate = new Date(this._shared.getMaxDate(this.timezone));
        this.dateRangeValue = [this.minDate, this.maxDate];
        this.getDashboardData();
      }
      this.admin_id = this._local.customGetItem('admin_profile') ? (this._local.customGetItem('admin_profile').admin_id) : 0;
      if (!this.embedded) {
        this.setUploadButtonAccess();
      }
      this.syncAllProductExportAccess(this.mainService.admin_array());
    });

    // this.getDashboardData();
    this.minDates = this.datePipe.transform(this.minDate, 'yyyy-MM-dd')
    this.today_start_date = this.datePipe.transform(this.maxDate, 'yyyy-MM-dd');
    this.today_end_date = this.datePipe.transform(this.maxDate, 'yyyy-MM-dd');
    this.dateForm = this._fb.group({
      start_date: [''],
      end_date: ['']
    });
    this.uploadForm = this._fb.group({
      notes: ['']
    });
  }

  get canExportAllProducts(): boolean {
    return this.canExportAllProductsAccess;
  }

  private syncAllProductExportAccess(allowedAdmins: any = this._local.customGetItem('admin_array')): void {
    const normalized = !allowedAdmins
      ? []
      : Array.isArray(allowedAdmins)
        ? allowedAdmins.map((id: any) => Number(id)).filter((id: number) => !Number.isNaN(id))
        : String(allowedAdmins)
            .replace(/^\[|\]$/g, '')
            .split(',')
            .map((id: string) => Number(id.trim()))
            .filter((id: number) => !Number.isNaN(id));

    this.canExportAllProductsAccess = normalized.includes(Number(this.admin_id));
  }

  setUploadButtonAccess() {
    const allowedAdmins = this._local.customGetItem('reporting_btn_allowed_admins');
    if (Array.isArray(allowedAdmins)) {
      this.canUploadRecoveryReporting = allowedAdmins.map((id: any) => Number(id)).includes(Number(this.admin_id));
      return;
    }

    this._api.api({}, 'auth/get_settings', 'get')
      .subscribe((response: any) => {
        const backendAllowedAdmins = Array.isArray(response?.reporting_btn_allowed_admins)
          ? response.reporting_btn_allowed_admins
          : [];
        this._local.customSetItem('reporting_btn_allowed_admins', backendAllowedAdmins);
        this.canUploadRecoveryReporting = backendAllowedAdmins.map((id: any) => Number(id)).includes(Number(this.admin_id));
      });
  }

  // sendMessage() {
  //   this.dashboardService.sendMsg({
  //     is_dummy: this.is_dummy
  //   });
  // }

  collapseHandler(value: any) {
    console.log(value);
    this.opened = value;
    // this.firstOpened = value;
  }

  openUploadModal() {
    this.uploadForm.reset();
    this.selectedFile = null;
    this.selectedFileName = '';
    const uploadModal = document.getElementById('uploadModal');
    if (uploadModal) {
      const modal = new (window as any).bootstrap.Modal(uploadModal);
      modal.show();
    }
  }

  onFileSelected(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      const validExcelTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'text/csv'];
      const validExtensions = ['.xlsx', '.xls', '.csv'];
      
      const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
      const isValidType = validExcelTypes.includes(file.type) || validExtensions.includes(fileExtension);
      
      if (!isValidType) {
        this._shared.customPopups('Only Excel files (.xlsx, .xls) or CSV files are allowed', 1);
        this.selectedFile = null;
        this.selectedFileName = '';
        event.target.value = '';
        return;
      }
      
      this.selectedFile = file;
      this.selectedFileName = file.name;
    }
  }

  submitUpload() {
    const notes = this.uploadForm.get('notes')?.value;

    if (!notes || !notes.trim()) {
      this._shared.customPopups('Please enter notes', 1);
      return;
    }

    if (!this.selectedFile) {
      this._shared.customPopups('Please select a file', 1);
      return;
    }

    const reader = new FileReader();

    reader.onload = (e: any) => {
      try {
        const binaryStr = e.target.result;

        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        let hasSheetRows = false;

        const accounts = workbook.SheetNames.flatMap((sheetName) => {
          const sheet = workbook.Sheets[sheetName];

          if (!sheet) {
            return [];
          }

          // Excel -> JSON for each sheet
          const rawData: any[] = XLSX.utils.sheet_to_json(sheet);

          if (rawData.length > 0) {
            hasSheetRows = true;
          }

          return rawData
            .filter(row => row['Account Number'])
            .map(row => {
              const rawStatus = row['Account Status']?.toString().trim();
              const numericStatus = Number(rawStatus);

              return {
                account_number: row['Account Number']?.toString().trim(),
                account_status: rawStatus === undefined || rawStatus === ''
                  ? null
                  : (Number.isNaN(numericStatus) ? rawStatus : numericStatus),
                customer_city: row['Customer City']?.toString().trim(),
                customer_state: row['Customer State']?.toString().trim(),
                customer_zip: row['Customer Zip']?.toString().trim(),
                customer_address_line_1: row['Customer Address Line 1']?.toString().trim(),
              };
            });
        });

        if (!hasSheetRows) {
          this._shared.customPopups('Excel file is empty', 1);
          return;
        }

        if (accounts.length === 0) {
          this._shared.customPopups('No valid data found in file', 1);
          return;
        }

        //  Final payload (IMPORTANT CHANGE)
        const uploadData = {
          notes: notes.trim(),
          admin_id: this.admin_id,
          timestamp: new Date(),
          accounts: accounts   //  ARRAY ADDED HERE
        };

        console.log('Uploading:', uploadData);

        this._api.api(uploadData, 'dashboard/upload_recuvery_reporting', 'post')
          .subscribe((response: any) => {
            console.log('Upload response:', response);

            const responseNotFoundAccounts = Array.isArray(response?.not_found_accounts) ? response.not_found_accounts : [];
            const showResultModal = !!response && (!response.is_error || responseNotFoundAccounts.length > 0);

            if (showResultModal) {
              this.uploadedAccountCount = accounts.length;
              this.notFoundAccounts = responseNotFoundAccounts;
              this.uploadResultMessage = response?.message || 'Upload completed';
              this.uploadForm.reset();
              this.clearSelectedFile();

              this.hideModal('uploadModal');
              this.showModal('uploadResultModal');

            } else {
              this._shared.customPopups(response?.message || 'Error uploading', 1);
            }
          }, (error) => {
            console.error('Upload error:', error);
            this._shared.customPopups('Error uploading: ' + error?.message, 1);
          });

      } catch (err) {
        console.error(err);
        this._shared.customPopups('Invalid Excel format', 1);
      }
    };

    reader.readAsBinaryString(this.selectedFile);
  }

  triggerFileUpload() {
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  clearSelectedFile() {
    this.selectedFile = null;
    this.selectedFileName = '';
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  closeUploadResultModal() {
    this.hideModal('uploadResultModal');
    this.notFoundAccounts = [];
    this.uploadedAccountCount = 0;
    this.uploadResultMessage = '';
  }

  exportNotFoundAccounts() {
    if (!this.notFoundAccounts || this.notFoundAccounts.length === 0) {
      this._shared.customPopups('No not-found accounts to export', 1);
      return;
    }

    const exportData = this.notFoundAccounts.map((account: any) => ({
      'Account ID': (account ?? '').toString().toUpperCase(),
      'Status': 'Not Found'
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = {
      Sheets: { 'Not_Found_Accounts': worksheet },
      SheetNames: ['Not_Found_Accounts']
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `Reporting_Account_IDs.xlsx`;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }

  private showModal(modalId: string) {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  private hideModal(modalId: string) {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const modal = (window as any).bootstrap.Modal.getOrCreateInstance(modalElement);
      modal.hide();
    }
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
    // this.timezone_subscription.unsubscribe();
    if (this.country_subscription) {
      this.country_subscription.unsubscribe(); 
    }
  }
  getSelectedTimezoneOffset() {
    if (this.timezone) {
      return (parseInt(this.timezone.substring(0, this.timezone.length - 2)) * 60) + parseInt(this.timezone.substring(this.timezone.length - 2))
    } else {
      return null;
    }
  }
  getDashboardData() {
    let data = {
      is_dummy: this.is_dummy,
      timezone_offset: this.getSelectedTimezoneOffset(),
    };
    this._api.api(data, 'dashboard/get_data_for_dashboard', 'get')
      .subscribe((data: any) => {
        if (data && !data.is_error) {
          this.dashboard = data.data;
        }
      });
  }

  exportAllProductAccounts() {
    // Either all-product download blocks the other, as before — the job service only knows
    // about its own key, and the disabled toggle can be bypassed with the menu already open.
    if (this.allProductExporting) {
      this.announceAllProductExportStart(false);
      return;
    }

    const started = this._exportJobs.start(
      this.ALL_PRODUCT_ACCOUNTS_JOB,
      'All Products Accounts export',
      this._api.exportApi(this.buildAllProductExportParams(), 'finance/export_all_product_accounts'),
      {
        next: (response: any) => {
          const requestsList = Array.isArray(response?.data) ? response.data : [];
          if (!requestsList.length) {
            this._shared.customPopups('No accounts found to export', 2);
            return;
          }

          const list: any[] = [this.buildAllProductExportHeaders()];
          requestsList.forEach((item: any) => {
            item.services = this.flattenServiceRecord(item.contract_service_record);
            list.push(this.buildAllProductExportRow(item));
          });
          this._shared.exportAsExcelFile(list, 'All Products Accounts', '.xlsx');
          this._shared.customPopups('All Products Accounts export is ready', 3);
        },
        error: (error: any) => {
          console.error('All product accounts export failed:', error);
          this._shared.customPopups('All Products Accounts export failed, please try again', 1);
        }
      }
    );

    this.announceAllProductExportStart(started);
  }

  exportAllProductTloData() {
    // See exportAllProductAccounts — one all-product export at a time, either kind.
    if (this.allProductExporting) {
      this.announceAllProductExportStart(false);
      return;
    }

    const started = this._exportJobs.start(
      this.ALL_PRODUCT_TLO_JOB,
      'All Products TLO export',
      this._api.exportApi(this.buildAllProductExportParams(), 'finance/export_all_product_tlo'),
      {
        next: (response: any) => {
          const requestsList = Array.isArray(response?.data) ? response.data : [];
          if (!requestsList.length) {
            this._shared.customPopups('No TLO records found to export', 2);
            return;
          }

          const list: any[] = [this.buildAllProductTloHeaders()];
          requestsList.forEach((item: any) => list.push(this.buildAllProductTloRow(item)));
          this._shared.exportAsExcelFile(list, 'All Products TLO', '.xlsx');
          this._shared.customPopups('All Products TLO export is ready', 3);
        },
        error: (error: any) => {
          console.error('All product TLO export failed:', error);
          this._shared.customPopups('All Products TLO export failed, please try again', 1);
        }
      }
    );

    this.announceAllProductExportStart(started);
  }

  /**
   * The top progress bar covers the running case from every page, so a start toast would
   * only duplicate it. This is left for the rejected click, where the bar alone doesn't
   * explain why nothing happened.
   */
  private announceAllProductExportStart(started: boolean) {
    if (!started) {
      this._shared.customPopups('An export is already running. The file will download when it is ready.', 2);
    }
  }

  
  private buildAllProductTloHeaders(): any {
    return {
      account_type: 'Account Type',
      account_id: 'Account ID',
      patient_first_name: 'Customer First Name',
      patient_last_name: 'Customer Last Name',
      patient_address: 'Customer Address',
      patient_city: 'Customer City',
      patient_state_code: 'State Code',
      patient_zip: 'Customer Zip',
      dob: 'Date Of Birth',
      ssn: 'Customer SSN',
      patient_mobile: 'Customer Mobile',
      patient_email: 'Customer Email',
      date_added: 'Request Date',
      debt_duration: 'Overdue From',
      days_past_due: 'Days',
      is_collection_allowed: 'Collection Allowed State',
      business_name: 'Business Name',
      data_type: 'TLO Data',
      tlo_status: 'TLO Lookup',
      split_status: 'Status',
      debt_status: 'Debt Type'
    };
  }

  private buildAllProductTloRow(item: any): any {
    return {
      account_type: item.qr_from == 1 ? 'Denefits' : item.qr_from == 2 ? 'Lendee' : item.qr_from == 3 ? 'Credee' : 'Recuvery',
      account_id: item.account_id || '-',
      patient_first_name: item.patient_first_name || '-',
      patient_last_name: item.patient_last_name || '-',
      patient_address: [item.patient_address, item.address_line2].filter(Boolean).join(' ') || '-',
      patient_city: item.city || '-',
      patient_state_code: item.state_code || '-',
      patient_zip: item.zip || '-',
      dob: this.datePipe.transform(item.patient_dob, 'MM/dd/yyyy', '+0000') || '-',
      // Full SSN, not the masked form the accounts export writes — a skip-trace
      // file is matched on it.
      ssn: item.patient_ssn ? `*****${item.patient_ssn_last_4}` : '-',
      patient_mobile: this._shared.maskContact(item.patient_mobile) || '-',
      patient_email: this._shared.maskContact(item.patient_email) || '-',
      date_added: this.datePipe.transform(item.date_added, 'MM/dd/yyyy', '+0000') || '-',
      debt_duration: this.datePipe.transform(item.debt_duration, 'MM/dd/yyyy', '+0000') || '-',
      // Current Days Past Due as a bare day count, computed server-side.
      days_past_due: item.days_past_due === null || item.days_past_due === undefined ? '-' : item.days_past_due,
      is_collection_allowed: item.is_collection_allowed && item.patient_address ? 'State Allowed' : item.patient_address ? 'State Not Allowed' : '-',
      business_name: item.practice_name ? item.practice_name : '-',
      data_type: item.data_type === 'TLO' ? 'YES' : 'NO',
      tlo_status: (item.split_tlo_status == 1) ? 'Disable' : 'Enable',
      split_status: item.split_status || '-',
      debt_status: item.debt_type == 1 ? 'Consumer' : 'Commercial'
    };
  }

  private flattenServiceRecord(contractServiceRecord: any): string {
    try {
      const services = JSON.parse(contractServiceRecord) || [];
      return services
        .map((entry: any) => (Array.isArray(entry.service) ? entry.service : [entry.service]).join(', '))
        .join(', ');
    } catch {
      return '';
    }
  }

  private buildAllProductExportParams(): any {
    return { is_export: 1 };
  }

  private buildAllProductExportHeaders(): any {
    return {
      account_type: 'Account Type',
      account_id: 'Account ID',
      patient_first_name: 'Customer First Name',
      patient_last_name: 'Customer Last Name',
      patient_email: 'Customer Email',
      patient_mobile: 'Customer Mobile',
      patient_address: 'Customer Address',
      patient_city: 'Customer City',
      patient_state: 'Customer State',
      patient_state_code: 'State Code',
      patient_zip: 'Customer Zip',
      date_added: 'Request Date',
      ssn: 'Customer SSN/EIN',
      is_email_sent: 'Email Notice Sent',
      email_sent_date: 'Email Notice Sent Date',
      dob: 'Date Of Birth',
      payment_link: 'Payment Link',
      debt_duration: 'Overdue From',
      total_service_amount: 'Total Service Amount',
      service_amount: 'Total Amount',
      discount_percent: 'Discount Percent',
      financed_amount: 'Final Amount',
      services: 'Services',
      admin_name: 'Assigned To',
      last_call_agent_name: 'Agent Action By',
      last_call_date: 'Last Call Timestamp',
      olb_upload_date: 'OLB Upload Date',
      last_call_source: 'Last Call Source',
      plan_created_date: 'Contract Created',
      contract_id: 'Contract ID',
      is_collection_allowed: 'Collection Allowed State',
      is_collection_enabled: 'Collection Enabled',
      stop_collection_reason: 'Stop Collection Reason',
      contract_status: 'Contract Status',
      is_written_off: 'Debt Written Off',
      is_charged_off: 'Debt Charge Off',
      is_canceled: 'Debt Canceled',
      is_debt_disputed: 'Issue Reported',
      is_bankrupt: 'Bankruptcy',
      is_deceased: 'Deceased',
      is_bureau_reported: 'Reported to Credit Bureau',
      debt_dispute_date: 'Issue Reported Date',
      dispute_status: 'Issue Reported Status',
      decease_date: 'Decease Date',
      bankrupt_date: 'Bankruptcy Date',
      dl_status: 'Demand letter Status',
      business_name: 'Business Name',
      last_action_date: 'Last action date',
      data_type: 'TLO Data',
      split_status: 'Status',
      demand_letter_count: 'Demand Letter Count',
      tlo_status: 'TLO Lookup',
      medical_reporting: 'Medical Reporting Status',
      new_to_notification: 'Account Movement - New To Notification',
      notification_to_collection: 'Account Movement - Notification To Collection',
      e_consent_status: 'E-Consent Provided',
      recuvery_score: 'Recovery Score',
      account_potential: 'Account Potential',
      debt_status: 'Debt Type',
      registration_number: 'Customer Registration Number'
    };
  }

  private buildAllProductExportRow(item: any): any {
    // Account Movement only applies to Recuvery (0) and Lendee (2) accounts. The
    // list reads that off its own product filter; here it has to come off the
    // row, since one file carries all four.
    const isValidQr = item.qr_from == 0 || item.qr_from == 2;
    const proposalDate = item.proposal_sent_date;
    const demandDate = item.demand_letter_date;
    const smallerDate = (proposalDate && demandDate)
      ? (new Date(proposalDate) < new Date(demandDate) ? proposalDate : demandDate)
      : (proposalDate || demandDate);

    return {
      account_type: item.qr_from == 1 ? 'Denefits' : item.qr_from == 2 ? 'Lendee' : item.qr_from == 3 ? 'Credee' : 'Recuvery',
      account_id: item.contract_code ? item.contract_code : (item.contract_patient_token + '').toLocaleUpperCase(),
      patient_first_name: item.patient_first_name,
      patient_last_name: item.patient_last_name,
      patient_email: this._shared.maskContact(item.patient_email) || '-',
      patient_mobile: this._shared.maskContact(item.patient_mobile) || '-',
      patient_address: (item.patient_address || '') + ' ' + (item.address_line2 || ''),
      patient_city: item.city,
      patient_state: item.state,
      patient_state_code: item.state_code || item.state || '-',
      patient_zip: item.zip,
      date_added: this.datePipe.transform(item.date_added, 'MM/dd/yyyy', '+0000'),
      ssn: item.patient_ssn ? `*****${item.patient_ssn_last_4}` : '-',
      is_email_sent: item.is_proposal_sent ? 'Notice Sent' : 'Notice not sent',
      email_sent_date: item.proposal_sent_date ? this.datePipe.transform(item.proposal_sent_date, 'MM/dd/yyyy', '+0000') : '-',
      dob: this.datePipe.transform(item.patient_dob, 'MM/dd/yyyy', '+0000') || '-',
      payment_link: 'https://request.recuvery.com/debt-recuvery/' + item.contract_patient_token,
      debt_duration: this.datePipe.transform(item.debt_duration, 'MM/dd/yyyy'),
      total_service_amount: currencyFormatfunction(item.total_service_amount) || '-',
      service_amount: currencyFormatfunction(item.service_amount),
      discount_percent: item.discount_percent || 0,
      financed_amount: currencyFormatfunction(item.treatment_amount),
      services: item.services || '-',
      admin_name: item.admin_name || '-',
      last_call_agent_name: item.last_call_agent_name || '-',
      last_call_date: this.datePipe.transform(item.last_call_date, 'MM/dd/yyyy') || '-',
      olb_upload_date: this.datePipe.transform(item.olb_upload_date, 'MM/dd/yyyy') || '-',
      last_call_source: item.last_call_source,
      plan_created_date: item.plan_created_date ? this.datePipe.transform(item.plan_created_date, 'MM/dd/yyyy', '+0000') : '-',
      contract_id: item.pf_contract_code || '-',
      is_collection_allowed: item.is_collection_allowed && item.patient_address ? 'State Allowed' : item.patient_address ? 'State Not Allowed' : '-',
      is_collection_enabled: item.stop_collection == 1 ? 'Collection Disabled' : 'Collection Enabled',
      stop_collection_reason: item.stop_collection_reason || '-',
      contract_status: item.pf_status ? (item.pf_status == 3 ? 'Overdue' : item.pf_status == 4 ? 'Completed' : item.pf_status == 5 ? 'Canceled' : 'Active') : '-',
      is_written_off: item.debt_written_off === 2 ? 'Write Off Pending' : item.debt_written_off === 1 ? 'Written Off' : 'Not Write Off',
      is_charged_off: item.debt_charge_off === 2 ? 'Charge Off Pending' : item.debt_charge_off === 1 ? 'Charged Off' : 'Not Charge Off',
      is_canceled: item.debt_canceled === 2 ? 'Cancellation Pending' : item.debt_canceled === 1 ? 'Cancelled' : 'Not Cancelled',
      is_debt_disputed: item.is_debt_disputed == 1 || (item.admin_dispute_status == 2 && item.is_debt_disputed == 0) ? 'Issue Reported' : 'Issue Not Reported',
      is_bankrupt: item.is_bankrupt ? 'Bankrupt' : 'Not bankrupt',
      is_deceased: item.is_deceased ? 'Deceased' : 'Not Deceased',
      is_bureau_reported: item.export_to_m2r_report == 1 ? 'Reporting Enabled' : item.export_to_m2r_report == 2 ? 'Reporting Disabled' : item.export_to_m2r_report == 4 ? 'Reporting Completed' : item.export_to_m2r_report == 5 ? 'Reporting Awaiting Action' : '-',
      debt_dispute_date: item.dispute_account_date ? this.datePipe.transform(item.dispute_account_date, 'MM/dd/yyyy', '+0000') : '-',
      dispute_status: item.admin_dispute_status == 1 ? 'Valid' : item.admin_dispute_status == 2 ? 'Invalid' : '-',
      decease_date: item.decease_date ? this.datePipe.transform(item.decease_date, 'MM/dd/yyyy', '+0000') : '-',
      bankrupt_date: item.bankrupt_date ? this.datePipe.transform(item.bankrupt_date, 'MM/dd/yyyy', '+0000') : '-',
      dl_status: item.demand_letter_count > 0 ? 'Printed' : 'Not Printed',
      business_name: item.business_name ? item.business_name : item.practice_name,
      last_action_date: item.last_action_on ? this.datePipe.transform(item.last_action_on, 'MM/dd/yyyy', this.timezone) : '-',
      data_type: item.data_type === 'TLO' ? 'YES' : 'NO',
      split_status: item.split_status,
      demand_letter_count: item.demand_letter_count,
      tlo_status: (item.split_tlo_status == 1) ? 'Disable' : 'Enable',
      medical_reporting: item.is_mr_allowed == 1 ? 'Allowed' : item.is_mr_allowed == 0 ? 'Banned' : 'N/A',
      new_to_notification: isValidQr && smallerDate
        ? this.datePipe.transform(smallerDate, 'MM/dd/yyyy', this.timezone) || '-'
        : '-',
      notification_to_collection: item.proposal_log_date
        ? this.datePipe.transform(item.proposal_log_date, 'MM/dd/yyyy', this.timezone)
        : '-',
      e_consent_status: item.debt_type == 1 ? (item.business_consent_confirmed || item.e_consent_status == 1 ? 'Verified' : 'Not Verified'): '',
      recuvery_score: item.recuvery_score ? item.recuvery_score : 'N.A.',
      account_potential: this.getScoreCategory(item.recuvery_score) || 'N.A.',
      debt_status: item.debt_type == 1 ? ' Consumer' : 'Commercial',
      registration_number: item.registration_number ? item.registration_number : '-'
    };
  }

  private getScoreCategory(score: any): string {
    if (score === null || score === undefined || score === '') return '';
    const numScore = Number(score);
    if (isNaN(numScore)) return '';
    if (numScore < 400) return 'Lowest';
    if (numScore < 500) return 'Low';
    if (numScore < 550) return 'Medium';
    if (numScore < 700) return 'High';
    return 'Highest';
  }

  formatDate(date: Date): string {
    // Get year, month, day directly without shifting for timezone
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getWeeklyData() {
    const startDate = this.formatDate(this.dateForm.value.start_date);
    const endDate = this.formatDate(this.dateForm.value.end_date);
    const data = {
      startDate,
      endDate
    };
    this._api.api(data, 'guest/get_weekly_stats_data')
      .subscribe((data: any) => {
        if (data && !data.is_error && data.data) {
          const worksheet = XLSX.utils.json_to_sheet([data.data]);
          const workbook = { Sheets: { 'Weekly_Report': worksheet }, SheetNames: ['Weekly_Report'] };
          const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

          // Create Blob and download without file-saver
          const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'Weekly_Report.xlsx';
          link.click();
        }
      });
  }
}